module.exports = __webpack_public_path__ + "static/hero-2-img-2-5c92c6a72b3b6ce676d4f499a0773a30.png";